import { StyleSheet, Text, View, Image, TouchableOpacity, Dimensions, StatusBar, ScrollView, ImageBackground, TextInput, TouchableWithoutFeedback, FlatList, Alert} from 'react-native';
import React, {useRef, useState, useEffect, Component} from 'react';
import { FontAwesome5, Feather, MaterialIcons } from '@expo/vector-icons'
import AppLoader, { showLoader, loaderRef, hideLoader } from './AppLoader';
import { SafeAreaView } from 'react-native-safe-area-context';
import { ActivityIndicator } from 'react-native';
import * as SQLite from 'expo-sqlite';
import * as RootNavigation from '../RootNavigation';
import { createRecentTable, getRecents } from './getData';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { PricingCard } from "@rneui/themed";


const {width, height} = Dimensions.get('window')



  
export default class Buy extends Component {
  constructor(props) {
    super(props);
    this.state = {
            plans: [],
            email: this.props.route.params.user.email,
            
            
        }

        
  
      }

      componentDidMount() {
      
      showLoader();
      //get plans from server
      console.log(this.state.email)
      fetch('http://ios.breketefamily.com/getPlans.php',
      { method: 'GET' })
      .then((response) => response.json())
      .then((responseJson) => {
        // console.log(responseJson)
        if (responseJson.status == 0 && responseJson.plans) {
          this.setState({plans: responseJson.plans}, () => {
            hideLoader()
          });
      
          
         

        }else{
          hideLoader();
          
        } 
      })
      .catch((error) => {
        console.error(error);
      });

        //get data from api
        
      }

render(){

  return (
    <SafeAreaView>
    <View style={{flex:1}}>
      <AppLoader ref = { loaderRef } />
     
      </View>
      {
        this.state.plans.length > 0 ?
        <FlatList
        data={this.state.plans}
        renderItem={({item}) => 
        <PricingCard
          color="#4f9deb"
          title={item.plan_name}
          price={'N'+item.plan_price}
          info={[item.plan_days+' days']}
          button={{ title: "Buy", iconColor: "#fff", titleColor: "#fff" }}
          onButtonPress={() => {
            // console.log(item.id)
            this.props.navigation.navigate('Payment', {plan: item.id, email: this.state.email, amount: item.plan_price, days: item.plan_days})
          }}
        />
        }
        keyExtractor={item => item.id}
        />
        :
        <View style={{flex:1, justifyContent:'center', alignItems:'center'}}>
          <Text>No plans available</Text>
           </View>
           }
    
    </SafeAreaView>

  );
}
 

}

const styles = StyleSheet.create({


// CAROUSEL STYLES

carouselImage: {
    width: 200, 
    height: 320, 
    borderRadius: 10, 
    alignSelf: 'center',
    backgroundColor: 'rgba(0,0,0,0.9)'
},
carouselText: {
    paddingLeft: 14,
    color: 'white', 
    position: 'absolute', 
    bottom: 10, 
    left: 2, 
    fontWeight: 'bold'
},
carouselIcon: {
    position: 'absolute', 
    top: 15, 
    right: 15
},
carouselContentContainer: {
    flex: 1,
    backgroundColor: '#000',
    height: 720,
    paddingHorizontal: 14
  },
SearchboxContainer: {
    flexDirection: 'row',
    marginVertical: 20, 
    width: '95%',
    alignSelf: 'center', 
    backgroundColor: '#fff', 
    elevation: 10,
    borderRadius: 4,
  },
  Searchbox: {
    padding: 12,
    paddingLeft: 20,
    fontSize: 16,
  },
  SearchboxIcon: {
    position: 'absolute', 
    right: 20, 
    top: 14
  },
  ImageBg: {
    flex: 1,
    height: null,
    width: null,
    opacity: 1,
    justifyContent: 'flex-start',  
  },
  carouselContainerView: {
    width: '100%',
    height:350 ,
    justifyContent: 'center',
    alignItems: 'center',
},
  carousel: {
    flex:1,
    overflow: 'visible',
} ,
movieInfoContainer: {
  flexDirection: 'row', 
  marginTop: 16, 
  justifyContent: 'space-between', 
  width: Dimensions.get('window').width - 14
},
movieName: {
  paddingLeft: 14,
  color: 'white', 
  fontWeight: 'bold', 
  fontSize: 20,
  marginBottom: 6
},
movieStat: {
  paddingLeft: 14,
  color: 'white', 
  fontWeight: 'bold', 
  fontSize: 14, 
  opacity: 0.8
},
playIconContainer: {
  backgroundColor: '#212121',
  padding: 18,
  borderRadius: 40,
  justifyContent: 'center',
  alignItems: 'center',
  elevation: 25,
  borderWidth: 4,
  borderColor: 'rgba(2, 173, 148, 0.2)',
  marginBottom: 14
}
});
